module.exports = __webpack_public_path__ + "static/media/theMofG17.bfaf024a.png";